import { BRAND_PALETTE } from '@worldcoo/shared/brand-palette';

/** The brand's dark stroke; the hub's white-stroke variant passes `ink` instead. */
export const INK = BRAND_PALETTE.webInk;
export const ACCENT = BRAND_PALETTE.webOrange;
/** The cream a drawing's cards and screens are filled with; on a dark ground the hub passes `paper` instead. */
export const PAPER = '#FFF7ED';

export function lineStyle(ink?: string, strokeWidth?: number) {
	return { stroke: ink ?? INK, strokeWidth, strokeLinecap: 'round', strokeLinejoin: 'round' } as const;
}

/** A label makes the drawing an image; without one it is decoration, as an `<img alt="">` was. */
export function illustrationA11y(label?: string) {
	return label ? { 'role': 'img', 'aria-label': label } : { 'aria-hidden': true };
}
